import { InfoContactAction } from "Components/InfoContact/Redux/actions";

export interface IInfoContact {
  isFetching: boolean;
  isFetchFailed: boolean;
  content: Julius.Website.ContactPageViewModel;
};

const initialInfoContact: IInfoContact = {
  isFetching: false,
  isFetchFailed: false,
  content: null,
};

function infoContact(
  state: IInfoContact = initialInfoContact, 
  action: InfoContactAction,
  ): IInfoContact {
    
  switch (action.type) {
    case 'SET_IS_FETCHING_CONTACT_CONTENT':
      return {
        ...state,
        isFetching: true,
        isFetchFailed: false,
      };

    case 'SET_FETCH_CONTACT_CONTENT_FAILED':
      return {
        ...state,
        isFetching: false,
        isFetchFailed: true,
      };

    case 'SET_CONTACT_CONTENT':
      return {
        ...state,
        content: action.content,
        isFetching: false,
        isFetchFailed: false,
      };

    default:
      return state;
  }
}

export default infoContact;


// WEBPACK FOOTER //
// ./src/components/InfoContact/Redux/reducer.tsx